import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TkTablePagination from "../../../components/atoms/TkTablePagination";
import { changeAmountFormat } from "../../../utils/useTools";
import "./_style.scss";

export const ScrollTable = (props: any) => {
  const { bodyList, totalList, maxTimes } = props;
  const [showBody, setShowBody] = useState(bodyList);
  const [headList, setHeadList] = useState<any>([]);
  const [maxLength, setMaxLength] = useState(0);

  const headListSticky = [
    { headTitle: "都道府県", sticky: true },
    { headTitle: "概算交付申請所要額", sticky: true },
    { headTitle: "追加交付申請所要額", sticky: true },
    { headTitle: "補助金所要額合計", sticky: true },
    { headTitle: "入金額合計", sticky: true },
  ];

  useEffect(() => {
    let array = [];
    for (let i = 1; i <= maxTimes; i++) {
      array.push({
        top: { headTitle: `${i}回目` },
        bottom: [
          { headTitle: "決定日" },
          { headTitle: "請求日" },
          { headTitle: "入金予定日" },
          { headTitle: "入金日" },
          { headTitle: "納付額" },
        ],
      });
    }

    setHeadList(array);
    setMaxLength(maxTimes);
  }, [maxTimes]);

  const handleOnGetPaginList = (paginList: any) => {
    setShowBody(paginList);
  };

  const TkTableCell = (props: any) => {
    const { headTitle, sticky } = props;

    return (
      <TableCell
        style={{
          left: sticky && 170 * props.index,
          position: sticky && "sticky",
          backgroundColor: "#bfe9db",
        }}
        className="tableCell"
        align="center"
        rowSpan={props.rowSpan || 1}
        colSpan={props.colSpan || 1}
      >
        {headTitle}
      </TableCell>
    );
  };

  return (
    <Box className="SCRW210001Table" data-testid="SCRW210001Table">
      <Box className="tkTableHeader">
        <Box className="tkTableHeaderLeft"></Box>

        <Box className="tkTableHeaderPagin">
          <TkTablePagination
            count={bodyList?.length}
            paginList={bodyList}
            onGetPaginList={handleOnGetPaginList}
          />
        </Box>

        <Box className="tkTableHeaderRight">
          <Typography>金額単位(円)</Typography>
        </Box>
      </Box>
      <TableContainer className="tkTableContainer">
        <Table className="tkTable">
          <TableHead className="tkTableHead">
            <TableRow>
              {headListSticky?.map((item: any, index: number) => (
                <React.Fragment key={`sticky-${index}`}>
                  <TkTableCell {...item} index={index} rowSpan={2} />
                </React.Fragment>
              ))}
              {headList?.map((item: any, index: any) => (
                <React.Fragment key={`top-${index}`}>
                  {item.top && <TkTableCell {...item.top} colSpan={5} />}
                </React.Fragment>
              ))}
            </TableRow>
            <TableRow>
              {headList?.map((item: any, index: number) => {
                return (
                  <React.Fragment key={`bottom-${index}`}>
                    {item.bottom &&
                      item.bottom.map((bottomItem: any, index: number) => {
                        return (
                          <React.Fragment key={`bottom-index-${index}`}>
                            <TkTableCell {...bottomItem} />
                          </React.Fragment>
                        );
                      })}
                  </React.Fragment>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody className="tkTableBody">
            {showBody?.length ? (
              showBody?.map((bodyItem: any, index: number) => {
                return (
                  <TableRow className="tableRow" key={index}>
                    {bodyItem.map((item: any, index: number) => {
                      const { children, sticky, align } = item;

                      return (
                        <TableCell
                          style={{
                            left: sticky && 170 * index,
                            position: sticky && "sticky",
                            backgroundColor: "#f7fafc",
                          }}
                          className="tableCell"
                          align={align}
                          key={index}
                        >
                          {children}
                        </TableCell>
                      );
                    })}

                    {Array.from({
                      length: maxLength - bodyItem.length,
                    }).map((_, index: any) => {
                      return (
                        <TableCell
                          key={`${index}-${index}`}
                          className="tableCell"
                        />
                      );
                    })}
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell
                  className="empty"
                  colSpan={headList?.length}
                  style={{ paddingLeft: (document?.documentElement?.clientWidth ?? 1000) / 2 }}
                >
                  <div>データがありません。</div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box className="tkTableHeader">
        <Box className="tkTableHeaderLeft"></Box>

        <Box className="tkTableHeaderPagin">
          <TkTablePagination
            count={bodyList?.length}
            paginList={bodyList}
            onGetPaginList={handleOnGetPaginList}
          />
        </Box>
      </Box>

      {totalList && (
        <Box mb={2} className="totalTable">
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="tableCell" key="total">
                  合計
                </TableCell>
                {totalList?.map((item: any, index: any) => (
                  <React.Fragment key={`total-${index}`}>
                    <TableCell className="tableCell" align="right">
                      {changeAmountFormat(item)}
                    </TableCell>
                  </React.Fragment>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      )}
    </Box>
  );
};

export default ScrollTable;
